import { themed } from '@indeed/ifl-css';

const visuallyHiddenStyles = {
  border: 0,
  clip: "rect(0 0 0 0)",
  blockSize: "1px",
  marginBlockStart: "-1px",
  marginBlockEnd: "-1px",
  marginInlineStart: "-1px",
  marginInlineEnd: "-1px",
  overflow: "hidden",
  paddingBlockStart: 0,
  paddingBlockEnd: 0,
  paddingInlineStart: 0,
  paddingInlineEnd: 0,
  position: "absolute",
  inlineSize: "1px",
  // https://medium.com/@jessebeach/beware-smushed-off-screen-accessible-text-5952a4c2cbfe
  whiteSpace: "nowrap",
  wordWrap: "normal"
};

/**
 * @see https://experience.indeed.design/components/ids/visually-hidden
 */
const VisuallyHidden = /*#__PURE__*/themed("span", process.env.NODE_ENV === "production" ? {
  target: "esbq1260"
} : {
  target: "esbq1260",
  label: "VisuallyHidden"
})(visuallyHiddenStyles, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlZpc3VhbGx5SGlkZGVuLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUF5QjhCIiwiZmlsZSI6IlZpc3VhbGx5SGlkZGVuLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IHRoZW1lZCwgU3R5bGVQcm9wcyB9IGZyb20gXCJAaW5kZWVkL2lmbC1jc3NcIjtcblxuZXhwb3J0IGNvbnN0IHZpc3VhbGx5SGlkZGVuU3R5bGVzID0ge1xuICBib3JkZXI6IDAsXG4gIGNsaXA6IFwicmVjdCgwIDAgMCAwKVwiLFxuICBibG9ja1NpemU6IFwiMXB4XCIsXG4gIG1hcmdpbkJsb2NrU3RhcnQ6IFwiLTFweFwiLFxuICBtYXJnaW5CbG9ja0VuZDogXCItMXB4XCIsXG4gIG1hcmdpbklubGluZVN0YXJ0OiBcIi0xcHhcIixcbiAgbWFyZ2luSW5saW5lRW5kOiBcIi0xcHhcIixcbiAgb3ZlcmZsb3c6IFwiaGlkZGVuXCIsXG4gIHBhZGRpbmdCbG9ja1N0YXJ0OiAwLFxuICBwYWRkaW5nQmxvY2tFbmQ6IDAsXG4gIHBhZGRpbmdJbmxpbmVTdGFydDogMCxcbiAgcGFkZGluZ0lubGluZUVuZDogMCxcbiAgcG9zaXRpb246IFwiYWJzb2x1dGVcIixcbiAgaW5saW5lU2l6ZTogXCIxcHhcIixcbiAgLy8gaHR0cHM6Ly9tZWRpdW0uY29tL0BqZXNzZWJlYWNoL2Jld2FyZS1zbXVzaGVkLW9mZi1zY3JlZW4tYWNjZXNzaWJsZS10ZXh0LTU5NTJhNGMyY2JmZVxuICB3aGl0ZVNwYWNlOiBcIm5vd3JhcFwiLFxuICB3b3JkV3JhcDogXCJub3JtYWxcIlxufSBhcyBjb25zdDtcblxuLyoqXG4gKiBAc2VlIGh0dHBzOi8vZXhwZXJpZW5jZS5pbmRlZWQuZGVzaWduL2NvbXBvbmVudHMvaWRzL3Zpc3VhbGx5LWhpZGRlblxuICovXG5leHBvcnQgY29uc3QgVmlzdWFsbHlIaWRkZW4gPSB0aGVtZWQoXCJzcGFuXCIpPFN0eWxlUHJvcHM+KHZpc3VhbGx5SGlkZGVuU3R5bGVzKTtcblxuVmlzdWFsbHlIaWRkZW4uZGlzcGxheU5hbWUgPSBcIlZpc3VhbGx5SGlkZGVuXCI7XG4iXX0= */");
VisuallyHidden.displayName = "VisuallyHidden";

export { VisuallyHidden, visuallyHiddenStyles };
